import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    ActivatedRouteSnapshot
} from '@angular/router';
import { ApiAnnuaireService } from '../../services/api-annuaire.service';


@Injectable()
export class SingleAnnuaireResolve implements Resolve<any> {
    constructor(private _apiService: ApiAnnuaireService, private router: Router) { }
    
    resolve(route: ActivatedRouteSnapshot): Promise<any> | boolean {
        let id = route.params['id'];
        return this._apiService.getEntreprise(id).then(result => {
            console.log('resolver single :', result);
            if (result) {
                return result;
            } else { // id not found
                this.router.navigate(['/annuaire']);
                return false;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/annuaire/single/resolver/single.resolve.service.ts